import { default as Pagination } from './paginationWithQs';
import PaginationWithState from './paginationWithState';

export default Pagination;
export { Pagination, PaginationWithState };
